import CloseIcon from "@mui/icons-material/Close";
import LaunchIcon from "@mui/icons-material/Launch";
import {
  Button as MuiButton,
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  Stack,
} from "@mui/material";
import { type RecentlyVisitedPage } from "@src/appV2/lib/utils/useRecentlyVisited";
import { type UseModalState } from "@src/lib/ui-react";

interface RecentlyViewedAccountsDialogProps {
  modalState: UseModalState;
  recentVisited: RecentlyVisitedPage[] | undefined;
  isAdmin: boolean;
  onAccountSelect: (account: { user: { userId: string; name: string }; type: string }) => void;
}

export function RecentlyViewedAccountsDialog({
  modalState,
  recentVisited,
  isAdmin,
  onAccountSelect,
}: RecentlyViewedAccountsDialogProps) {
  if (!recentVisited) {
    return null;
  }

  return (
    <Dialog fullWidth open={modalState.modalIsOpen} maxWidth="sm" onClose={modalState.closeModal}>
      <DialogTitle
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        Recently Viewed Accounts
        <IconButton size="small" onClick={modalState.closeModal}>
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent
        sx={{
          maxHeight: "60vh",
          minHeight: "25vh",
          overflow: "auto",
          py: 2,
          px: 3,
        }}
      >
        <Stack spacing={1}>
          {recentVisited.slice(isAdmin ? 0 : 1).map((item) => (
            <MuiButton
              key={item.id}
              fullWidth
              variant="outlined"
              endIcon={<LaunchIcon />}
              sx={{ py: 1 }}
              onClick={() => {
                modalState.closeModal();
                onAccountSelect({
                  user: { userId: item.id, name: item.title },
                  type: item.type,
                });
              }}
            >
              <span>{item.title}</span>
            </MuiButton>
          ))}
        </Stack>
      </DialogContent>
    </Dialog>
  );
}
